import { render, staticRenderFns } from "./dictManage.vue?vue&type=template&id=6ceb4e7a&scoped=true"
import script from "./dictManage.vue?vue&type=script&lang=js"
export * from "./dictManage.vue?vue&type=script&lang=js"
import style0 from "./dictManage.vue?vue&type=style&index=0&id=6ceb4e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ceb4e7a",
  null
  
)

export default component.exports